import { forwardRef } from 'react';
import { TabNav as RadixTabNav } from '@radix-ui/themes';
import { cn } from '@/lib/utils';

/* Documentation for Radix Themes TabNav
https://www.radix-ui.com/themes/docs/components/tab-nav
*/
type TabNavRootProps = React.ComponentProps<typeof RadixTabNav.Root> & {
  /** Pulp variant: `nav` = embedded full-width bottom nav bar; default = stock underline tabs. */
  variant?: 'nav';
};

const Root = forwardRef<HTMLElement, TabNavRootProps>(({ className, variant, ...props }, ref) => (
  <RadixTabNav.Root
    ref={ref}
    data-variant={variant}
    className={cn(variant === 'nav' && 'tabnav-nav', className)}
    {...props}
  />
));
Root.displayName = 'TabNav.Root';

type TabNavLinkProps = React.ComponentProps<typeof RadixTabNav.Link>;

const Link = forwardRef<HTMLAnchorElement, TabNavLinkProps>(({ className, ...props }, ref) => (
  <RadixTabNav.Link ref={ref} className={cn(className)} {...props} />
));
Link.displayName = 'TabNav.Link';

const TabNav = { Root, Link };

export { TabNav };
export type { TabNavRootProps, TabNavLinkProps };
